import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator';
import { createOdooLead } from '../../services/odooClient';


const ContactForm = (props) => {

    const [forms, setForms] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        company: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [submitting, setSubmitting] = useState(false);
    const [validator] = useState(new SimpleReactValidator({
        className: 'errorMessage'
    }));
    const changeHandler = e => {
        setForms({ ...forms, [e.target.name]: e.target.value })
        if (validator.allValid()) {
            validator.hideMessages();
        } else {
            validator.showMessages();
        }
    };

    const submitHandler = async e => {
        e.preventDefault();
        if (validator.allValid()) {
            try {
                setSubmitting(true);
                setStatus({ type: '', message: '' });
                validator.hideMessages();

                const response = await createOdooLead({
                    name: forms.subject || `Website enquiry from ${forms.name}`,
                    email: forms.email,
                    phone: forms.phone,
                    message: forms.message,
                });

                setForms({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    company: '',
                    message: ''
                });
                setStatus({
                    type: 'success',
                    message: response?.message || 'Thanks for contacting us. Our team will get back to you shortly.'
                });
            } catch (error) {
                // Ensure we display a string message (backend may return objects)
                let errorMessage = 'Unable to submit. Please try again later.';
                try {
                    if (!error) errorMessage = 'Unknown error';
                    else if (typeof error === 'string') errorMessage = error;
                    else if (error.message) errorMessage = error.message;
                    else errorMessage = JSON.stringify(error);
                } catch (e) {
                    errorMessage = 'Unknown error';
                }
                setStatus({ type: 'error', message: errorMessage });
            } finally {
                setSubmitting(false);
            }
        } else {
            validator.showMessages();
        }
    };

    return (
        <form onSubmit={(e) => submitHandler(e)} className="contact-form">
            {status.message && (
                <div
                    style={{
                        marginBottom: '20px',
                        padding: '12px 16px',
                        borderRadius: '8px',
                        fontSize: '15px',
                        backgroundColor: status.type === 'success' ? '#eaf8f0' : '#fdecea',
                        color: status.type === 'success' ? '#2d7a46' : '#c63737',
                        border: `1px solid ${status.type === 'success' ? '#b5e2c1' : '#f5c2c2'}`
                    }}
                >
                    {status.message}
                </div>
            )}
            <div className="row">
                <div className="col-lg-6">
                    <div className="input-field">
                        <label htmlFor="text1">Name*</label>
                        <div className="input-box">
                            <input
                                value={forms.name}
                                type="text"
                                name="name"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('name', forms.name, 'required|alpha_space')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="input-field">
                        <label htmlFor="text2">Email*</label>
                        <div className="input-box">
                            <input
                                value={forms.email}
                                type="email"
                                name="email"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('email', forms.email, 'required|email')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field">
                        <label htmlFor="text3">Phone*</label>
                        <div className="input-box">
                            <input
                                value={forms.phone}
                                type="phone"
                                name="phone"
                                className="form-control"
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)} />
                            {validator.message('phone', forms.phone, 'required|phone')}
                        </div>
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="input-field text-field">
                        <label htmlFor="text5">Message</label>
                        <div className="input-box">
                            <textarea
                                onBlur={(e) => changeHandler(e)}
                                onChange={(e) => changeHandler(e)}
                                value={forms.message}
                                type="text"
                                name="message"
                                className="form-control"
                                placeholder="How can we help you?">
                            </textarea>
                            {validator.message('message', forms.message, 'required')}
                        </div>
                    </div>
                </div>
            </div>
            <div className="cp-det-btn mt-20 d-grid">
                <button className="cp-btn" type='submit' disabled={submitting}>
                    {submitting ? 'Sending...' : 'Send us a message'} <i className="fal fa-arrow-right"></i>
                </button>
            </div>
        </form>
    )
}

export default ContactForm;
